<template>
  <van-toast v-model:show="loading" :duration="0" :forbidClick="true">
    <template #message>
      <van-loading color="#fff" size="24px" vertical>加载中...</van-loading>
    </template>
  </van-toast>
</template>
<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { useStore } from "@/store";
const env = import.meta.env;

const { loading } = storeToRefs(useStore());
</script>
<style lang="less" scoped>
.van-loading {
  padding: 30px;
}
</style>
